import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomH2, RowFlex, SectionCol } from '../../../components/SEO';
import {
  cityPropTypes,
  FROM_DESTINATION_LINKS,
  FROM_ORIGIN_LINKS,
  linksPropTypes,
  TO_DESTINATION_LINKS,
  TO_ORIGIN_LINKS,
} from '../constants';
import { LinkList } from './LinkList';
import messages from './messages';

const LinkSection = ({ destinationCity, links, originCity }) => (
  <Fragment>
    {links[FROM_ORIGIN_LINKS].length > 0 && (
      <RowFlex>
        <SectionCol>
          <CustomH2>
            <FormattedMessage
              {...messages.fromLinksHeader}
              values={{
                city: originCity.name,
              }}
            />
          </CustomH2>
          <LinkList links={links[FROM_ORIGIN_LINKS]} />
        </SectionCol>
      </RowFlex>
    )}
    {links[TO_ORIGIN_LINKS].length > 0 && (
      <RowFlex>
        <SectionCol>
          <CustomH2>
            <FormattedMessage
              {...messages.toLinksHeader}
              values={{
                city: originCity.name,
              }}
            />
          </CustomH2>
          <LinkList links={links[TO_ORIGIN_LINKS]} />
        </SectionCol>
      </RowFlex>
    )}
    {links[FROM_DESTINATION_LINKS].length > 0 && (
      <RowFlex>
        <SectionCol>
          <CustomH2>
            <FormattedMessage
              {...messages.fromLinksHeader}
              values={{
                city: destinationCity.name,
              }}
            />
          </CustomH2>
          <LinkList links={links[FROM_DESTINATION_LINKS]} />
        </SectionCol>
      </RowFlex>
    )}
    {links[TO_DESTINATION_LINKS].length > 0 && (
      <RowFlex>
        <SectionCol>
          <CustomH2>
            <FormattedMessage
              {...messages.toLinksHeader}
              values={{
                city: destinationCity.name,
              }}
            />
          </CustomH2>
          <LinkList links={links[TO_DESTINATION_LINKS]} />
        </SectionCol>
      </RowFlex>
    )}
  </Fragment>
);

LinkSection.propTypes = {
  destinationCity: cityPropTypes,
  links: linksPropTypes,
  originCity: cityPropTypes,
};

export { LinkSection };
